<!--
 * @Author: ext.shuiqianning1
 * @Date: 2022-06-01 15:11:37
 * @LastEditors: 张东 zhangdong265@jd.com
 * @LastEditTime: 2023-04-07 11:14:23
 * @FilePath: /content-center/src/components/customize/AuditInfo.vue
-->
<template>
  <div class="auditInfo">
    <div class="auditName">
      <span>作者</span>
      <span v-if="originalAuthor">{{ originalAuthor.originalAuthorName }}</span>
    </div>
    <div class="auditJob" v-if="originalAuthor">
      <span>{{ originalAuthor.originalAuthorTitle }}</span>
      <span>{{ originalAuthor.originalAuthorUnit }}</span>
      <span>{{ originalAuthor.originalAuthorDepart }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "auditInfo",
  props: ["originalAuthor"]
};
</script>

<style lang="scss" scoped>
.auditInfo {
  .auditName {
    // width: 300px;
    height: 83px;
    padding: 40px 0 30px 24px;

    span {
      &:nth-child(1) {
        font-family: PingFangSC-Medium;
        font-size: 28px;
        color: #262626;
      }

      &:nth-child(2) {
        font-size: 28px;
        margin-left: 15px;
      }
    }
  }

  .auditJob {
    margin-top: 10px;
    padding: 0px 0 30px 18px;

    span {
      padding: 5px;
      font-family: PingFang-SC-Regular;
      font-size: 16px;
      color: #9a9a9a;
    }
  }
}
</style>
